<div class="certification-detail-container">
  <div class="container" *ngIf="personCertification">
    <div fxLayout="row" fxLayoutAlign="space-between" class="header-container">
      <h3>{{ editModeLabel }} Certification</h3>
    </div>
    <form [formGroup]="certificationDetailForm">
      <div fxLayout="column">
        <div fxLayoutAlign="space-between">
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
            <mat-label>Certification Name</mat-label>
            <input
              matInput
              type="text"
              placeholder="Certification Name"
              formControlName="name"
              [matAutocomplete]="auto"
            />
            <mat-error *ngIf="certificationDetailForm.get('name').hasError('required')">
              Certification Name is required
            </mat-error>
          </mat-form-field>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let cert of filteredCertifications | async" [value]="cert.name">
              {{ cert.name }}
            </mat-option>
          </mat-autocomplete>
        </div>
        <div fxLayoutAlign="space-between">
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
            <mat-label>Certification Number</mat-label>
            <input matInput type="text" formControlName="number" placeholder="Optional" />
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between" formGroupName="dateGroup">
          <div>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Issue Date</mat-label>
              <input
                matInput
                [matDatepicker]="startPicker"
                formControlName="startDate"
                [errorStateMatcher]="matcher"
                placeholder="Optional"
              />
              <mat-datepicker-toggle matSuffix [for]="startPicker"> </mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
              <mat-error *ngIf="dateFormGroup.hasError('startDateBeforeEndDate')">
                Issue date is after the expiration date
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Expiration Date</mat-label>
              <input
                matInput
                [matDatepicker]="endPicker"
                formControlName="endDate"
                [errorStateMatcher]="matcher"
                placeholder="Optional"
              />
              <mat-datepicker-toggle matSuffix [for]="endPicker"> </mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div fxLayoutAlign="space-between">
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
            <mat-label>Certification URL</mat-label>
            <input matInput type="text" formControlName="url" placeholder="Optional" />
          </mat-form-field>
        </div>

        <mat-dialog-actions>
          <div class="button-container" fxLayoutAlign="center center">
            <button
              mat-raised-button
              color="primary"
              [disabled]="!(certificationDetailForm.valid && certificationDetailForm.dirty)"
              (click)="save()"
            >
              <mat-icon>check</mat-icon>Save
            </button>
            <button type="button" mat-button (click)="close()"><mat-icon>close</mat-icon>Cancel</button>
          </div>
        </mat-dialog-actions>
      </div>
    </form>
  </div>
</div>
